import { useCallback } from 'react'
import { Link } from 'react-router-dom'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'

import Button from '@material-ui/core/Button'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centered: {
      margin: '0 auto',
    },
    left: {
      marginRight: 'auto',
    },
  }),
)

export const TaskDetailSurvey: React.FC = () => {
  return (
    <Typography variant='body2'>
      To get started with your project, head over to the{' '}
      <Link to='/project/info'>Project Info tab</Link> and fill out the required information. The
      goal of this step is to define the project scope and provide important metadata which will be
      integrated directly into the UBEM in some cases, and be a useful reference for the energy
      modeler in others.
    </Typography>
  )
}

export const TaskActionSurvey: React.FC = () => {
  const classes = useStyles()
  const { goToTab } = useTabNavigation()
  const goToInfoSurvey = useCallback(() => {
    goToTab('./info')
  }, [goToTab])

  return (
    <Button
      onClick={goToInfoSurvey}
      variant='contained'
      color='primary'
      size='small'
      className={classes.left}
    >
      Project Info
    </Button>
  )
}
